/**
 * Counts time, can be paused and resumed.
 */
const now = () => Date.now();

export class TimeTrack {
    get isRunning(): boolean {
        return this._isRunning;
    }

    public get startTime(): number {
        return this._started;
    }

    private _started = NaN;
    private _paused = NaN;
    private _tid = NaN;

    private _isRunning = false;

    constructor(public readonly interval: number = 250, private onTick?: () => void) {}

    public start(): void {
        this._isRunning = true;
        this._started = now();
        this.startTimer();
    }
    public stop(): void {
        this._isRunning = false;
        clearInterval(this._tid);
    }

    public pause(): void {
        if (this._isRunning) {
            this._paused = now();
            clearInterval(this._tid);
            this._isRunning = false;
        }
    }

    public resume(): void {
        if (!this._isRunning) {
            this._started += now() - this._paused;
            this.start();
        }
    }

    // total time
    public getTotalTime(): number {
        return now() - this._started;
    }

    private startTimer() {
        const tick = () => this.onTick && this.onTick();
        clearTimeout(this._tid); // just for safety
        this._tid = setInterval(() => {
            tick();
        }, this.interval) as unknown as number;
        tick();
    }
}
